import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ms-popular-bets-pod-summary',
    standalone: true,
    template: '<div class="pod-summary">{{ summary() }}</div>',
    styleUrl: './popular-bets-pod-summary.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularBetsPodSummaryComponent {
    summary = input.required<string>();
}
